import { GeneralTaskProperty } from "./general-task-property";

export class GroupGeneralApprovalData {
  /**
   * Group
   */
  group: string;

  /**
   * The array of properties associated with the item.
   */
  properties: Array<GeneralTaskProperty> = [];

  /**
   * Constructor
   * @param data
   */
  constructor(data?: any) {
    if (data) {
      this.group = data.group;
      this.properties = data.properties ? data.properties : [];
    }
  }
}
